import React, { useState } from "react";
import { X } from "lucide-react";
import { STICKER_PACKS, stickerWebp, stickerGif } from "@/lib/stickers";

// Preloaded animated stickers & GIFs, arranged in categories (no key needed).
// Content: Google Noto Animated Emoji (public CDN).
// GIFs only — the stickers option was removed from the webapp picker.
export default function GifPicker({ onSelect, onClose }) {
  const [packKey, setPackKey] = useState(STICKER_PACKS[0].key);
  const pack = STICKER_PACKS.find((p) => p.key === packKey) || STICKER_PACKS[0];

  const pick = (cp) => {
    onSelect(stickerGif(cp), "gif");
    onClose();
  };

  return (
    <div className="px-3 py-3 border-t border-[var(--rc-border)] bg-[var(--rc-surface)] rc-pop" data-testid="gif-picker">
      <div className="flex items-center gap-2 mb-2">
        <div className="flex items-center gap-1 bg-[var(--rc-bg)] rounded-full p-1">
          <span data-testid="gif-tab-gifs" className="px-3 py-1 rounded-full text-sm font-semibold bg-[var(--rc-gold)] text-black">GIFs</span>
        </div>
        <span className="flex-1 text-sm text-[var(--rc-muted)] truncate">{pack.label}</span>
        <button onClick={onClose} data-testid="gif-close" className="h-8 w-8 grid place-items-center rounded-full text-[var(--rc-muted)] hover:text-[var(--rc-gold)]"><X size={18} /></button>
      </div>

      {/* Category chips */}
      <div className="flex gap-1.5 overflow-x-auto no-scrollbar pb-2 mb-1" data-testid="gif-categories">
        {STICKER_PACKS.map((p) => (
          <button key={p.key} onClick={() => setPackKey(p.key)} data-testid={`gif-cat-${p.key}`}
            className={`shrink-0 rounded-full border px-3 py-1 text-xs font-medium transition-colors ${packKey === p.key ? "border-[var(--rc-gold)] text-[var(--rc-gold)] bg-[var(--rc-gold)]/10" : "border-[var(--rc-border)] text-[var(--rc-muted)]"}`}>
            {p.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-4 gap-2 max-h-56 overflow-y-auto no-scrollbar" data-testid="gif-grid">
        {pack.items.map((cp) => (
          <button key={cp} onClick={() => pick(cp)} data-testid={`gif-item-${cp}`}
            className={`aspect-square grid place-items-center rounded-xl p-1.5 hover:ring-2 hover:ring-[var(--rc-gold)] bg-[var(--rc-bg)]`}>
            <img src={stickerWebp(cp)} alt="" className="w-full h-full object-contain" loading="lazy" />
          </button>
        ))}
      </div>
      <p className="mt-1.5 text-center text-[10px] text-[var(--rc-muted)]">Animated GIFs · Noto Emoji</p>
    </div>
  );
}
